export function StatusBadge({
  on,
  onLabel,
  offLabel,
}: {
  on: boolean;
  onLabel: string;
  offLabel: string;
}) {
  return <span className={`badge ${on ? 'ok' : 'warn'}`}>{on ? onLabel : offLabel}</span>;
}
